import React from 'react';
import PropTypes from 'prop-types';

import styles from './SurveySectionPageNumber.scss';

const SurveySectionEditorPageNumber = ({ number }) => (
  <div className={styles.pagination} data-e2e="page-number">
    Page {number}
  </div>
);

SurveySectionEditorPageNumber.propTypes = {
  number: PropTypes.number.isRequired,
};

export default SurveySectionEditorPageNumber;
